import React from 'react';
import { Link } from 'react-router-dom';
import './PragroupLegal.css';

import homeLogo from '../../../../assets/newlogo/logo-home.png';
export default function PragroupLegal({ badge, title, updated, children }) {
  return (
    <div className="pg-legal">
      <nav className="pg-legal-nav">
        <div className="pg-legal-container pg-legal-nav__inner">
          <Link to="/" className="pg-legal-nav__logo">    <img style={{width:"130px"}} src={homeLogo} alt="PRA Group Logo" /></Link>
          <ul className="pg-legal-nav__links">
            <li><Link to="/#features">Features</Link></li>
            <li><Link to="/#security">Security</Link></li>
            <li><Link to="/#portfolio">Portfolio</Link></li>
            <li><Link to="/#faq">FAQ</Link></li>
          </ul>
          <Link to="/" className="pg-legal-nav__back">&larr; Back to Home</Link>
        </div>
      </nav>
      <section className="pg-legal-hero">
        <div className="pg-legal-container">
          <span className="pg-legal-badge">{badge}</span>
          <h1>{title}</h1>
          <p className="pg-legal-updated">{updated}</p>
        </div>
      </section>
      <div className="pg-legal-body">{children}</div>
      <footer className="pg-legal-footer">
        <div className="pg-legal-container">
          <div className="pg-legal-footer__grid">
            <div className="pg-legal-footer__brand">
              <Link to="/" className="pg-legal-nav__logo" style={{ fontSize: '1.25rem' }}><img style={{width:"120px"}} src={homeLogo} alt="PRA Group Logo" /></Link>
              <p>A trusted platform built to streamline your cryptocurrency journey with confidence and ease.</p>
                 <p><b>Registered office address:</b> Level 11 Riverside House, 2a Southwark Bridge Road, London, England, SE1 9HA</p>
           
            </div>
            <div className="pg-legal-footer__col">
              <h4>Product</h4>
              <ul>
                <li><Link to="/auth/login">Wallet</Link></li>
                <li><Link to="/#features">Staking</Link></li>
                <li><Link to="/#portfolio">Exchange</Link></li>
                <li><Link to="/#portfolio">Portfolio</Link></li>
              </ul>
            </div>
            <div className="pg-legal-footer__col">
              <h4>Legal</h4>
              <ul>
                <li><Link to="/privacy-policy">Privacy Policy</Link></li>
                <li><Link to="/terms-of-service">Terms of Service</Link></li>
                <li><Link to="/cookie-policy">Cookie Policy</Link></li>
                <li><Link to="/compliance">Compliance</Link></li>
              </ul>
            </div>
          </div>
          <div className="pg-legal-footer__bottom">
            <span>&copy; 2026 PRA Group. All rights reserved.</span>
          </div>
        </div>
      </footer>
    </div>
  );
}
